import { render } from "./UnreviewedUserClientsPosts.vue?vue&type=template&id=746e0e73&ts=true"
import script from "./UnreviewedUserClientsPosts.vue?vue&type=script&lang=ts"
export * from "./UnreviewedUserClientsPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__